<div class="wrapper">
  <app-delivery></app-delivery>
</div>